/**
 * HIPAA-safe logger. Only outputs to console in development mode.
 * In production, console statements are suppressed to prevent PHI leakage.
 */
const IS_DEV = process.env.NODE_ENV === 'development';

export const logger = {
  error: (message, ...args) => {
    if (IS_DEV) console.error(message, ...args);
  },
  warn: (message, ...args) => {
    if (IS_DEV) console.warn(message, ...args);
  },
  info: (message, ...args) => {
    if (IS_DEV) console.log(message, ...args);
  },
};
